export { default } from './Paper';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Paper/index.js
// module id = 21
// module chunks = 0